module.exports = __webpack_public_path__ + "img/pic_3_tc.9e1142c3.png";